<script setup>
import {computed, ref, watch} from 'vue'

const props = defineProps({
  options: {
    type: Object,
    default: () => {}
  },
  name: {
    type: String,
    required: true
  },
  type: {
    type: String,
    default: 'checkbox'
  },
  column: Boolean,
  modelValue: {
    type: [Object, Array, String, Number, Boolean],
    default: null
  },
  disabled: Boolean
})

const emit = defineEmits(['update:modelValue'])

const computedValue = computed({
  get: () => props.modelValue,
  set: value => {
    emit('update:modelValue', value)
  }
})

const componentClass = computed(() => {
  const base = []

  if (props.disabled) {
    base.push('bg-gray-300')
  }

  return base
})

const inputType = computed(() => props.type === 'radio' ? 'radio' : 'checkbox')
</script>

<template>
  <div
    class="flex justify-start flex-wrap"
    :class="{'flex-col':column}"
  >
    <label
      v-for="(value, key) in options"
      :key="key"
      :class="type"
      class="mr-6 last:mr-0"
    >
      <input
        v-model="computedValue"
        :type="inputType"
        :name="name"
        :value="key"
        :disabled="disabled"

      >
      <span class="check" :class="componentClass" />
      <span class="control-label">{{ value }}</span>
    </label>
  </div>
</template>
